import {
    Box,
    Button,
    Grid,
    FormControl,
    FormLabel,
    Input,
    VStack,
    useToast,
    Heading,
    Card,
    CardHeader,
    CardBody,
    Divider,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useContractorProfile, useUpdateContractorProfile } from '../../services/contractor-profile.hooks';

export function CompanyInfoTab() {
    const toast = useToast();
    const { data: profile, isLoading } = useContractorProfile();
    const updateProfile = useUpdateContractorProfile();

    const [formData, setFormData] = useState({
        legal_name: '',
        dba_name: '',
        address: '',
        phone: '',
        email: '',
        tax_id: '',
        duns_number: '',
        cage_code: '',
        sam_uei: '',
    });

    useEffect(() => {
        if (profile) {
            setFormData({
                legal_name: profile.legal_name || '',
                dba_name: profile.dba_name || '',
                address: profile.address || '',
                phone: profile.phone || '',
                email: profile.email || '',
                tax_id: profile.tax_id || '',
                duns_number: profile.duns_number || '',
                cage_code: profile.cage_code || '',
                sam_uei: profile.sam_uei || '',
            });
        }
    }, [profile]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        updateProfile.mutate(formData, {
            onSuccess: () => {
                toast({
                    title: 'Profile Saved',
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                });
            },
            onError: () => {
                toast({
                    title: 'Failed to Save',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                });
            },
        });
    };

    if (isLoading) return <Box>Loading...</Box>;

    return (
        <Card>
            <CardHeader>
                <Heading size="md">Company Information</Heading>
            </CardHeader>
            <Divider color="gray.200" />
            <CardBody>
                <VStack spacing={6} align="stretch">
                    <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={6}>
                        <FormControl>
                            <FormLabel>Legal Name</FormLabel>
                            <Input name="legal_name" value={formData.legal_name} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>DBA Name</FormLabel>
                            <Input name="dba_name" value={formData.dba_name} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Address</FormLabel>
                            <Input name="address" value={formData.address} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Phone</FormLabel>
                            <Input name="phone" value={formData.phone} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Email</FormLabel>
                            <Input name="email" value={formData.email} onChange={handleChange} />
                        </FormControl>
                    </Grid>

                    <Heading size="sm" mt={4}>Identifiers</Heading>
                    <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={6}>
                        <FormControl>
                            <FormLabel>Tax ID (EIN)</FormLabel>
                            <Input name="tax_id" value={formData.tax_id} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>DUNS Number</FormLabel>
                            <Input name="duns_number" value={formData.duns_number} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>CAGE Code</FormLabel>
                            <Input name="cage_code" value={formData.cage_code} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>SAM.gov UEI</FormLabel>
                            <Input name="sam_uei" value={formData.sam_uei} onChange={handleChange} />
                        </FormControl>
                    </Grid>

                    <Button
                        colorScheme="brand"
                        alignSelf="flex-start"
                        mt={4}
                        onClick={handleSave}
                        isLoading={updateProfile.isPending}
                    >
                        Save Company Info
                    </Button>
                </VStack>
            </CardBody>
        </Card>
    );
}
